import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EcommerceTemplateService {


  url = environment.serverAPI4 + "/api";


  constructor(private http: HttpClient) { }

  saveEcommerceTemplate(ecommerceTemplate: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/ecommerceTemplate`, ecommerceTemplate)
  }

  getAllEcommerceTemplate(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}/ecommerceTemplate?page=${Page}&size=${size}&sort=${sort}`);
  }
  getEcommerceTemplateById(templateId: number): Observable<Object> {
    return this.http.get(`${this.url}/ecommerceTemplate/${templateId}`);
  }

  EcommerceTemplateSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/ecommerceTemplate/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/ecommerceTemplate/deleteImage`, data);
  }

   getAllTemplateDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/ecommerceTemplate/list`);
  }

  deleteByEcommerceTemplateId(templateId: any): Observable<Object> {
    return this.http.delete(`${this.url}/ecommerceTemplate/${templateId}`);
  }
}
